// Copyright (c) Move Closer 2023.

import { Injectable } from '@movecloser/front-core'
import { Locale } from 'vue-i18n'

import { ISiteService } from '../../../../contexts'

import { ILocaleContentManager, LocaleContentRule } from './contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Injectable()
export class LocaleContentManager implements ILocaleContentManager {
  private readonly siteService: ISiteService
  private config: LocaleContentRule

  constructor (config: LocaleContentRule, siteService: ISiteService) {
    this.config = config
    this.siteService = siteService
  }

  /**
   * @inheritDoc
   */
  public add<P extends string | number, T> (property: P, value: T, locale?: Locale): P {
    const _config = { ...this.config }
    const _locale = locale ?? this.siteService.getActiveSiteLocale().toLowerCase()
    this.config[_locale] = {
      ..._config[_locale],
      [property]: value
    }

    return this.retrieve<P>(property)
  }

  /**
   * @inheritDoc
   */
  public retrieve<P> (property: string | number, locale?: Locale): P {
    return this.config[locale ?? this.siteService.getActiveSiteLocale().toLowerCase()][property]
  }
}
